import { styled, Style } from 'inlines'

type LogoHeartOnlyProps = {
  width?: number
  height?: number
  style?: Style
}

export const LogoHeartOnly = ({
  width = 16,
  height = 16,
  style,
}: LogoHeartOnlyProps) => {
  return (
    <styled.svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M6.90012 13.4808C6.90012 13.4808 6.90012 13.5308 6.89012 13.5608C6.81012 13.4108 6.72012 13.2708 6.62012 13.1408C6.74012 13.2608 6.84012 13.3808 6.90012 13.4908"
        fill="white"
      />
      <path
        d="M7.05383 5.56078C7.11383 5.80078 7.41383 5.80078 7.48383 5.56078C8.49383 1.91078 13.1138 1.51078 13.1138 5.21078C13.1138 8.13078 7.94383 11.2408 7.55383 14.0008C6.62383 12.1808 3.18383 11.1908 3.18383 7.24078C3.18383 3.88078 6.45383 3.18078 7.05383 5.56078ZM7.47383 15.5208C7.59383 15.6508 7.77383 15.6208 7.85383 15.4508C9.78383 11.3708 15.6538 9.53078 15.6538 4.33078C15.6538 2.44078 14.3838 0.550781 11.9338 0.500781C9.60383 0.460781 7.52383 1.96078 7.30383 4.38078C7.23383 2.84078 6.23383 2.14078 5.06383 2.14078C2.77383 2.14078 0.903833 4.20078 1.00383 7.31078C1.16383 12.1908 5.85383 13.7308 7.46383 15.5208"
        fill="white"
      />
    </styled.svg>
  )
}
